import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutlayout_dimuident2 extends Layout {
    sourceDimuidents: DataSource;
    textboxDimuiDesc: Textbox;
    textboxDimuiIdent: Textbox;
}
